export enum EBookSort {
  ALL = 'all',
  RECENT = 'recent',
  POPULAR = 'popular',
}
